import { useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Seo from '../utils/Seo';
import logoNeg from '../assets/images/layout/nochedemuertos_neg.png';
import map1 from '../assets/images/homepage/map1.jpg';
import map2 from '../assets/images/homepage/map2.jpg';
import map3 from '../assets/images/homepage/map3.jpg';
import map4 from '../assets/images/homepage/map4.jpg';
import Book from '../assets/images/homepage/book.png';
import QR from '../assets/images/homepage/qr_phone.png';
import Valentina from '../assets/images/homepage/Homepage-Valentina.png';
import ValentinaBook from '../assets/images/homepage/home_book_v01.png';
import BookSection from './BookSection';
import '../css/homepage.css';
import Testimonials from './Testimonials';
import PopupModal from './PopupModal';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  // Arrays for left and right character classes (memoized)
  const leftCharacterClasses = useMemo(() => ['valentina1', 'tinskani1', 'choc1', 'taquito1'], []);
  const rightCharacterClasses = useMemo(() => ['valentina2', 'tinskani2', 'valentina3', 'taquito2'], []);

  // State for selected classes
  const [selectedLeftClass, setSelectedLeftClass] = useState(leftCharacterClasses[0]);
  const [selectedRightClass, setSelectedRightClass] = useState(rightCharacterClasses[0]);

  const [isOpen, setIsOpen] = useState(false);
  const modalRef = useRef(null);
  const navigate = useNavigate();

  // Function to randomly select a class from an array
  function getRandomClass(arr) {
    const randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
  }

  // On mount, pick random classes for left and right independently
  useEffect(() => {
    setSelectedLeftClass(getRandomClass(leftCharacterClasses));
    setSelectedRightClass(getRandomClass(rightCharacterClasses));
  }, [leftCharacterClasses, rightCharacterClasses]);

  const location = useLocation();
  const showBookRow = location.search.includes('book');

  return (
    <div className='mainMargin'>
      <Seo
        title="Bienvenidos a Noche de Muertos | Día de la Vida"
        description="Descubre la aventura de Valentina en el Día de Muertos."
      />
      <div id='homepage_top' className="sectionContainer">
        <div className="container mt-5 pb-5">

          <div className="row pb-3">
            <div className="col-md-5">
              <img
                src={logoNeg}
                alt="Noche de Muertos Día de la Vida"
                className="logo img-fluid"
                style={{ paddingBottom: '20px' }}
              />
            </div>
            <div className="col-md-7 align-self-center">
              <h1 style={{ display: 'none' }}>
                Libro Noches de Muertos Día de la Vida
              </h1>
              <h2>¿Quieres ser parte de la aventura?</h2>
              <h4>Sólo tienes que dar el primer paso...</h4>
            </div>
          </div>

          {showBookRow && (
            <div className="row mt-3" id="valentina_book">
              <div className="col-md-8 align-self-center">
                <div style={{ padding: '20px' }}>
                  <h2>Si estás viendo esto...</h2>
                  <h4>...¡Es que tienes mi libro en tus manos!</h4>
                  <p>
                    ¿Quieres saber cómo una niña normal como yo se aventó un viaje re loco, conociendo personajes alucinantes y descubriendo que era más valiente de lo que creía?
                    Entonces ESTA es la historia que necesitas leer. <b>¡Te juro que no te vas a arrepentir!</b>
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <img
                  src={ValentinaBook}
                  alt="Libro Noche de Muertos"
                  className="img-fluid" />
              </div>
            </div>
          )}

          <div className="row map g-0 mx-auto">
            <div className="map_piece map1 col-6">
              <Link
                to="/personajes"
                className="hover-brighten d-inline-block"
              >
                <img
                  src={map1}
                  alt="Mapa 1"
                  className="img-fluid"
                />
                <div className="over">Los personajes</div>
              </Link>
            </div>
            <div className="map_piece map2 col-6">
            <Link
                to="/capitulos"
                className="hover-brighten d-inline-block"
              >
                <img
                  src={map2}
                  alt="Mapa 2"
                  className="img-fluid"
                />
                <div className="over">Capítulos</div>
              </Link>
            </div>
            <div className="map_piece map3 col-6">
            <Link
                to="/el-libro"
                className="hover-brighten d-inline-block"
              >
                <img
                  src={map3}
                  alt="Mapa 3"
                  className="img-fluid"
                />
                <div className="over">El libro</div>
              </Link>
            </div>
            {/* <div className="map_piece map4 col-6">
              <img
                  src={map4}
                  alt="Mapa 4"
                  className="img-fluid"
                />
                <Link
                to="/section1"
                className="hover-brighten d-inline-block"
              >
                <img
                  src={map4}
                  alt="Mapa 4"
                  className="img-fluid"
                />
                <div className="over">Tienda</div>
              </Link>
            </div>  */}

            <div className="map_piece map4 col-6">
              <a
                href="#"
                className="hover-brighten d-inline-block"
                onClick={(e) => {
                  e.preventDefault();
                  setIsOpen(true);
                }}
                role="button"
                aria-label="Abrir información del libro"
              >
                <img
                  src={map4}
                  alt="Mapa 4"
                  className="img-fluid"
                />
                <div className="over">Tienda</div>
              </a>
            </div>

            <div className={`image-over left-img ${selectedLeftClass}`}></div>
            <div className={`image-over right-img ${selectedRightClass}`}></div>

          </div>

        </div>
      </div>

      <div id='homapage_valentina' className="sectionContainer">
        <div className="container pb-5">
          <div className="row flex-column-reverse flex-md-row pb-5 justify-content-center">
            <div className="col-md-6" style={{ textAlign: 'left' }}>
              <h2>¡Hola! ¡Yo soy Valentina!</h2>
              <p>
                Mi viaje familiar a Tzintzuntzan para el Día de Muertos siempre fue especial, pero ESTE AÑO se volvió una locura total. ¡Terminé metida en el inframundo, neta! Todo empezó cuando mi xoloitzcuintle Taquito se perdió... y acabé viviendo una aventura ÉPICA bajo el pueblo de mi abuela.
              </p>
              <p>
                Conocí guías alucinantes como Tinskani (un esqueleto-fantasma científico!!!), me enfrenté a dioses milenarios y descubrí que soy más valiente de lo que creía. ¿Quieren saber cómo una niña normal como yo sobrevivió a la tierra de los muertos? ¿O qué secretos esconde ese lugar? ¡Sigue leyendo porque esto se pone buenísimo!
              </p>
              <Link
                to="/personajes"
                className="c_button text-decoration-none fw-bold"
              >
                Haz clic aquí para conocer a mi amigos
              </Link>
            </div>
            <div className="col-md-6">
              <img
                src={Valentina}
                alt="Valentina"
                className="img-fluid"
                style={{  }}
              />
            </div>
          </div>
        </div>
      </div>

      <BookSection
        title="¿Ya conoces mi libro?"
        description="¡Si quieren saber cómo una chava normal como yo se aventó un viaje re loco, conociendo personajes alucinantes y descubriendo que era más valiente de lo que creía, entonces ESTA es la historia que necesitas leer! ¡Te juro que no te vas a arrepentir!"
        imgSrc={Book}
        linkText="Lo puedes comprar aquí"
        linkTo="https://wa.me/525551079711?text=Me%20gustar%C3%ADa%20adquirir%20el%20libro%20de%20Noche%20de%20Muertos%20/%20D%C3%ADa%20de%20la%20Vida"
      />

      <div id='homapage_qr' className="sectionContainer double_glyph">
        <div className="container pb-5 pt-5">
          <div className="row justify-content-center">
            <div className="col-md-12" style={{ marginBottom: '20px' }}>
              <h2>¿Ya tienes el libro?</h2>
              <h3>¡La aventura también es digital!</h3>
            </div>
            <div className="col-md-4" style={{ textAlign: 'left' }}>
              <p>
                Al final de cada capítulo vas a encontrar un código QR BIEN CHIDO. Si lo escaneas, vas a desbloquear un montón de contenido exclusivo que te va a volar la cabeza:
                <ul>
                  <li>Verás mis pensamientos reales sobre todo lo que me pasó</li>
                  <li>Descubrirás tarjetas secretas de TODOS (mis amigos, mi familia, aliados y hasta mis enemigos)</li>
                  <li>Podrás ver arte exclusivo que no aparece en el libro</li>
                </ul>
                <strong>¡Checa la página seguido! Siempre estaré subiendo cosas nuevas y... <i>guiño guiño...</i> nunca sabes qué sorpresa puede aparecer.</strong>
              </p>
            </div>
            <div className="col-md-4">
              <img
                src={QR}
                alt="Escanea el código QR"
                className="qr img-fluid"
              />
            </div>
          </div>
        </div>
      </div>

      {/* { <Testimonials /> } */}
      <PopupModal
              open={isOpen}
              onClose={() => setIsOpen(false)}
              title={'Prueba'}
              description={
                'Si deseas adquirir una copia, por favor contáctanos directamente y con gusto te ayudaremos a gestionar tu pedido.'
              }
              primary={{ label: 'Contacto por WhatsApp', href: 'https://wa.me/525551079711?text=Me%20gustar%C3%ADa%20adquirir%20el%20libro%20de%20Noche%20de%20Muertos%20/%20D%C3%ADa%20de%20la%20Vida' }}
              secondary={{ label: 'Contacto del Sitio', onClick: () => navigate('/contact') }}
            />
    </div>
  );
}